import { Card } from 'react-bootstrap';
import { PageCardWrapper } from '../../sitel/demon/ui/atoms';
import { FieldValidationErrorMsg, RequiredAsterisk } from '../../sitel/demon/ui/atoms/form';
import { InputText } from '../../sitel/demon/ui/form';
import { stateList } from '../../sitel/commons/services/lookups';
//TOBEDELTED 20240306 import { getDateYearsAgo, getDateYYYYMMDD } from '../../../sitel/commons/utilities/dates';

export default function BasicFormSection({ register, errors }) {
  return (
    <PageCardWrapper title='Personal Information'>
      <Card.Body>
        <div className='row mb-2'>
          <div className='form-group col-md-6'>
            <InputText labelText='First name' id='firstName' placeholder='Enter first name' showIsRequired maxlength='30' register={register} errors={errors} />
          </div>
          <div className='form-group col-md-6'>
            <InputText labelText='Last name' id='lastName' placeholder='Enter last name' showIsRequired maxlength='30' register={register} errors={errors} />
          </div>
        </div>

        <div className='row mb-2'>
          <div className='form-group col-lg-4'>
            <InputText labelText='Last 4 SSN' id='ssn4' placeholder='Enter last 4 SSN' showIsRequired maxlength='4' register={register} errors={errors} />
          </div>
   
          <div className='form-group col-lg-4'>
            <InputText labelText='Phone number' id='phone' placeholder='' showIsRequired maxlength='10' register={register} errors={errors} />
          </div>
        </div>

        <div className='row mb-2'>
          <div className='form-group col-md-6'>
            <InputText labelText='Address line 1' id='address1' placeholder='' showIsRequired maxlength='100' register={register} errors={errors} />
          </div>
          <div className='form-group col-md-6'>
            <InputText labelText='Address line 2' id='address2' placeholder='' maxlength='50' register={register} errors={errors} />
          </div>
        </div>

        <div className='row mb-2'>
          <div className='form-group col-lg-4'>
            <label htmlFor='city'>City</label>
            <RequiredAsterisk />
            <input type='text' className='form-control' id='city' maxLength='30' {...register('city')} />
            <FieldValidationErrorMsg field='city' errors={errors} />
          </div>

          <div className='form-group col-lg-4'>
            <label htmlFor='state'>State</label>
            <RequiredAsterisk />
            <select id='state' className='form-control' {...register('state')}>
              <option>Choose...</option>
              {stateList.map((stateDuplex) => {
                return (
                  <option key={stateDuplex[1]} value={stateDuplex[1]}>
                    {stateDuplex[0]}
                  </option>
                );
              })}
            </select>
            <FieldValidationErrorMsg field='state' errors={errors} />
          </div>
          
          <div className='form-group col-lg-4'>
            <label htmlFor='zip'>Zipcode</label>
            <RequiredAsterisk />
            <input type='text' className='form-control' id='zip' maxLength='5' {...register('zip')} />
            <FieldValidationErrorMsg field='zip' errors={errors} />
          </div>
        </div>
      </Card.Body>
    </PageCardWrapper>
  );
}
